"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getHasError = (errors) => {
    return !!Object.values(errors).find((e) => e !== "");
};
exports.default = getHasError;
//# sourceMappingURL=getHasError.js.map